import { cn } from '~/styles/extended-theme';

interface Props {
  className?: string;
}

export function GoogleLogo({ className }: Props) {
  return (
    <img className={cn('h-6 w-6', className)} src="/img/Google_Logo_Primary.png" alt="Google" />
  );
}
